import { GALLERY_TYPE } from './types';
import { containerClassName } from './classNameStrategies';
import galleryComponentWrapper from './components/GalleryComponentWrapper/gallery-component-wrapper';
import BadPlugin from '../../components/BadPlugin';
const galleryRenderDescriptor = (externalGalleryComponent)=>({
        component: externalGalleryComponent ? galleryComponentWrapper(externalGalleryComponent) : BadPlugin,
        classNameStrategies: {
            container: containerClassName
        }
    });
export function typeMapper(externalGalleryComponent) {
    return ()=>({
            [GALLERY_TYPE]: galleryRenderDescriptor(externalGalleryComponent)
        });
}
